import React, { useContext, useState } from 'react';
import Menu from './Menu';
import SettingsTutorial from '../SettingsTutorial';
import { UserContext } from '../../data/betslip/UserConf';

export default function MenuToggle() {
    const userContext = useContext(UserContext);
    const [toggled, setToggled] = useState(false);

    function handleClick() {
        if (!toggled === false) {
            const settings = window.getSettingsToSaveOnDB();
            if (settings != null) {
                userContext.saveSportFrontendConfiguration(settings);
            }
        }
        setToggled(!toggled);
    }

    return (
        <>
            <div className="h-6 w-6 flex items-center justify-center p-1 bg-cc2 rounded-md" onClick={handleClick}>
                {toggled ?
                    <i className="bi-x-lg text-lg text-cs1"></i>
                    :
                    <i className="bi-gear text-lg text-cs1"></i>
                }
            </div>
            {toggled &&
                <Menu toggle={handleClick} />
            }
            <SettingsTutorial />
        </>
    );
}
